import React from "react";
import { Image, Modal } from "react-bootstrap";
import brochureFile from "../../assets/pdf/Project Monitoring Group Brochure.pdf";
import _directDownload from "../../assets/download-icon.png";

export default function PmgModal(props) {
  const { show, closeModal } = props;

  return (
    <React.Fragment>
      <Modal show={show} dialogClassName="banner-modal" onHide={closeModal}>
        <Modal.Header closeButton className="pmg-header">
          <div className="banner-modal-header-box">
            <Modal.Title>Project Monitoring Group (PMG)</Modal.Title>
            <div className="brochure-box">
              <a
                href={brochureFile}
                type="application/pdf"
                target="_blank"
                className="pdf-wrapper manual-wrapper"
              >
                <Image src={_directDownload} alt="Issue Resolved" />
                Brochure
              </a>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body className="pmg-body">
          <p>
            The Project Monitoring Group (PMG), part of the newly established{" "}
            <b>Integrated Transport & Logistics Authority (ITLA)</b> under the
            Cabinet Secretariat, Government of India, is an institutional
            mechanism for <b>milestone-based monitoring of projects</b> and{" "}
            <b>expediting the resolution of issues</b> and{" "}
            <b>regulatory bottlenecks</b> in projects involving investments
            above ₹500 crore in India.
          </p>

          <p>
            Established as a special cell in the Cabinet Secretariat, Government
            of India, in 2013, PMG was brought under the administrative control
            of the Prime Minister’s Office (PMO) in 2015. In 2019, it was merged
            with Invest India under the Department for Promotion of Industry and
            Internal Trade (DPIIT), Ministry of Commerce and Industry, to
            provide investors with a one-stop facilitation mechanism across the
            investment lifecycle, including project monitoring and issue
            resolution. In August 2021, the PMO appointed PMG as the Secretariat
            to the Monitoring Group.{" "}
            <b>
              Since January 2026, PMG has been reporting to the Secretary
              (Coordination), Cabinet Secretariat.
            </b>
          </p>

          <p>
            Through milestone-based monitoring, PMG facilitates early
            identification of implementation challenges and timely corrective
            action to prevent delays and cost overruns. It supports public,
            private and Public–Private Partnership (PPP) projects by{" "}
            <b>facilitating approvals, addressing sectoral policy issues </b>{" "}
            and <b>resolving bottlenecks</b> through coordination among
            stakeholders, thereby supporting timely project commissioning.
          </p>

          <p>
            The projects being monitored on PMG are largely infrastructural in
            nature, however PMG enlists projects from other sectors as well as
            long as they meet the threshold requirement. These projects
            typically emanate from the following sectors:
          </p>

          <ul style={{ paddingLeft: "59px" }}>
            <li>Road Transport & Highways, Railways, Civil Aviation</li>
            <li>Inland Waterways, Ports and Shipping</li>
            <li>Chemicals, Fertilizers and Petrochemicals</li>
            <li>Power</li>
            <li>Coal and Mines</li>
            <li>Cement, Construction and Steel</li>
            <li>Urban Development</li>
            <li>Health and Family Welfare</li>
            <li>Textiles</li>
            <li>Tourism</li>
            <li>Telecommunication and IT Services</li>
          </ul>

          <p>
            The issues taken up by PMG are both at Union and State-Level. The
            issues include:
          </p>

          <ol className="list-body">
            <li>
              <h5>Union Ministries</h5>
              <ul className="list-body">
                <li>Environment, Forest and Wildlife Clearances</li>
                <li>Eco Sensitive Zone clearance</li>
                <li>Tree cutting permission</li>
                <li>Grant of Working permission by forest Department</li>
                <li>Approval for private railways siding construction</li>
                <li>Industrial License Permission</li>
                <li>Road Crossing of Pipelines/Transmission lines</li>
                <li>Grant of Right of Way</li>
                <li>Shifting of Utilities</li>
                <li>Any other central government clearance/approval</li>
              </ul>
            </li>
            <li>
              <h5>State Governments</h5>
              <ul className="list-body">
                <li>
                  Land Acquisition issues such as issue of Government
                  Notifications/ Disbursement of Compensation, transfer of title
                  and handing over of possession of land and related issues.
                </li>
                <li>Removal of encroachments</li>
                <li>
                  Approval and implementation of Relief and Rehabilitation plan
                </li>
                <li>
                  Issue of No Objection Certificate under Forest Rights Act
                </li>
                <li>Grant of Power and Water supply connections</li>
                <li>
                  Grant/ Issue of Consent to Establish (COE) and Consent to
                  Operate(COE) from State Pollution Control Board.
                </li>
                <li>Transfer of Government Land</li>
                <li>Support of State Govt agencies for Law and Order issues</li>
                <li>Grant of Right of Way/ Right of Use permission</li>
                <li>Any other state govt clearance/ approval</li>
              </ul>
            </li>
            {/* <li>
              <h5>Any other state govt clearance/ approval</h5>
            </li> */}
          </ol>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
